import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import { calculateLastActive } from 'utils/date';

const ClientCard = props => {
  const text = props.lastActive
    ? `Last Active ${calculateLastActive(props.lastActive)} ago`
    : 'Invited to Hybrid';
  return (
    <Avatar
      src={props.img}
      width="37"
      height="32"
      name={props.name}
      text={text}
      firstLetters={props.firstLetters}
      url={`/clients/${props.id}`}
    />
  );
};

export default ClientCard;
